





































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Theme = namespace("theme");

@Component({})
export default class Loader extends Vue {
  @Theme.Getter("getAccentColor") accentColor!: string;

  @Prop({
    default: "#fff",
  })
  primaryColor;

  @Prop({
    default: "25",
  })
  height;
}
